/**
 * API de Usuários
 * Integração com backend/routes/user_routes.py
 */
import apiService from '../core/apiService';
// ============================================================================
// User API Service
// ============================================================================
/**
 * Serviço de API de usuários
 * Métodos para gerenciamento de usuários, setores e perfis
 */
const userApi = {
    /**
     * Listar todos os usuários
     * @returns Lista de usuários
     */
    async getUsers() {
        try {
            const response = await apiService.get('/api/usuarios');
            return response;
        }
        catch (error) {
            console.error('Erro ao listar usuários:', error);
            throw error;
        }
    },
    /**
     * Criar novo usuário
     * @param userData - Dados do usuário
     * @returns Usuário criado
     */
    async createUser(userData) {
        try {
            const response = await apiService.post('/api/usuarios', userData);
            return response;
        }
        catch (error) {
            console.error('Erro ao criar usuário:', error);
            throw error;
        }
    },
    /**
     * Obter usuário por ID
     * @param userId - ID do usuário
     * @returns Dados do usuário
     */
    async getUserById(userId) {
        try {
            const response = await apiService.get(`/api/usuario/${userId}`);
            return response;
        }
        catch (error) {
            console.error('Erro ao obter usuário:', error);
            throw error;
        }
    },
    /**
     * Atualizar usuário
     * @param userId - ID do usuário
     * @param userData - Dados atualizados
     * @returns Usuário atualizado
     */
    async updateUser(userId, userData) {
        try {
            const response = await apiService.put(`/api/usuario/${userId}`, userData);
            return response;
        }
        catch (error) {
            console.error('Erro ao atualizar usuário:', error);
            throw error;
        }
    },
    /**
     * Excluir usuário
     * @param userId - ID do usuário
     * @returns Resultado da exclusão
     */
    async deleteUser(userId) {
        try {
            const response = await apiService.delete(`/api/usuario/${userId}`);
            return response;
        }
        catch (error) {
            console.error('Erro ao excluir usuário:', error);
            throw error;
        }
    },
    /**
     * Listar setores
     * @returns Lista de setores
     */
    async getSectors() {
        try {
            const response = await apiService.get('/api/setores');
            return response;
        }
        catch (error) {
            console.error('Erro ao listar setores:', error);
            throw error;
        }
    },
    /**
     * Listar perfis
     * @returns Lista de perfis
     */
    async getProfiles() {
        try {
            const response = await apiService.get('/api/perfis');
            return response;
        }
        catch (error) {
            console.error('Erro ao listar perfis:', error);
            throw error;
        }
    },
    async confirmarAvisoBoasVindas() {
        try {
            const response = await apiService.post('/api/usuarios/confirmar-aviso-boas-vindas');
            return response;
        }
        catch (error) {
            console.error('Erro ao confirmar aviso de boas-vindas:', error);
            throw error;
        }
    },
};
export default userApi;
